//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from "@angular/core";

//local imports
import { PresenterRegistration } from "@app/shared";
import { AbstractDepartmentModel, DepartmentDisplayMode } from "@app/catalog-common";


@PresenterRegistration({
   types: [AbstractDepartmentModel],
   key:"breadcrumb-item",
})
@Component({
    selector: 'department-breadcrumb-presenter',
    template: '<department-item [id]="data().id" [department]="data()" [displayMode]="DisplayMode.Code" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DepartmentBreadcrumbPresenterComponent {

    DisplayMode: typeof DepartmentDisplayMode = DepartmentDisplayMode;
    
    public data: WritableSignal<AbstractDepartmentModel>;
    
    constructor() {
        this.data = signal<AbstractDepartmentModel>(null);
    }
}